var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZoomInIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_18_2510)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 32,
    width: 32,
    height: 32,
    rx: 16,
    transform: "rotate(-90 4 32)",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0003 14.8847C11.0003 16.7946 11.7784 18.516 13.0045 19.7656C14.2541 21.0152 15.9752 21.7934 17.8852 21.7934C19.5593 21.7934 21.1154 21.1803 22.2942 20.19L23.3787 21.251C23.2608 21.6754 23.3787 22.1469 23.6852 22.4771L25.8544 24.6464C26.3495 25.1179 27.1511 25.1179 27.6464 24.6464C28.1179 24.1513 28.1179 23.3496 27.6464 22.8543L25.4771 20.6851C25.147 20.3786 24.6755 20.2607 24.2511 20.3786L23.1901 19.2941C24.1804 18.1151 24.7934 16.559 24.7934 14.885C24.7934 12.9752 24.0153 11.2538 22.7657 10.0042C21.516 8.77811 19.7949 8 17.8849 8C15.9751 8 14.2537 8.77811 13.0042 10.0042C11.7781 11.2539 11 12.975 11 14.885L11.0003 14.8847ZM17.2722 12.3854C17.2722 12.0317 17.5315 11.7488 17.8853 11.7488C18.239 11.7488 18.5219 12.0317 18.5219 12.3854V14.2717H20.3845C20.7382 14.2717 21.0211 14.531 21.0211 14.8847C21.0211 15.2384 20.7383 15.5214 20.3845 15.5214H18.5219V17.3841C18.5219 17.7378 18.239 18.0207 17.8853 18.0207C17.5316 18.0207 17.2722 17.7378 17.2722 17.3841V15.5214H15.386C15.0323 15.5214 14.7494 15.2385 14.7494 14.8847C14.7494 14.531 15.0323 14.2717 15.386 14.2717H17.2722V12.3854Z",
    fill: "#C7C7C7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_18_2510",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_18_2510"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_18_2510",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomInIcon);
export default __webpack_public_path__ + "static/media/zoom-in-icon.b1c7eeeedfd47efb2c345a47e8687c52.svg";
export { ForwardRef as ReactComponent };